import {
  RecurrenceSchedule,
  RecurrenceScheduleFrequency
} from "@wingspanhq/wingspan-api-sdk";

const UNIT_BY_FREQUENCY: Partial<Record<RecurrenceScheduleFrequency, string>> =
  {
    [RecurrenceScheduleFrequency.DAILY]: "day",
    [RecurrenceScheduleFrequency.WEEKLY]: "week",
    [RecurrenceScheduleFrequency.MONTHLY]: "month",
    [RecurrenceScheduleFrequency.ANNUAL]: "year"
  };

const EVERY_LABEL_BY_FREQUENCY: Partial<
  Record<RecurrenceScheduleFrequency, string>
> = {
  [RecurrenceScheduleFrequency.DAILY]: "Daily",
  [RecurrenceScheduleFrequency.WEEKLY]: "Weekly",
  [RecurrenceScheduleFrequency.MONTHLY]: "Monthly",
  [RecurrenceScheduleFrequency.SEMI_MONTHLY]: "Twice a month",
  [RecurrenceScheduleFrequency.ANNUAL]: "Yearly"
};

export const selectorRecurrenceCadenceLabel = (
  schedule?: RecurrenceSchedule
): string => {
  const frequency = schedule?.frequency;

  if (!frequency) {
    return "One-off";
  }

  const interval = schedule?.interval ?? 1;
  const unit = UNIT_BY_FREQUENCY[frequency];

  if (interval > 1 && unit) {
    return `Every ${interval} ${unit}s`;
  }

  return EVERY_LABEL_BY_FREQUENCY[frequency] ?? "Recurring";
};
